export function toast(options) {
  dispatchCustomEvent(document, 'toast', { detail: options})
}

export function disable(element) {
  dispatchCustomEvent(element, 'galette:disable')
}

export function enable(element) {
  dispatchCustomEvent(element, 'galette:enable')
}

export function setContent(element, content) {
  dispatchCustomEvent(element, 'galette:setContent', { detail: { content } })
}

export function setFrameSrc(element, src) {
  dispatchCustomEvent(element, 'galette:setFrameSrc', { detail: { src } })
}

export function openModal(element) {
  dispatchCustomEvent(element, 'modal:open')
}

export function tabChanged(element, detail) {
  dispatchCustomEvent(element, 'tablist:tabChanged', { detail })
}

export function dispatchCustomEvent(element, name, options) {
  // we add a timeout here to make the dispatch asynchronous
  // and to make sure that it occurs after all controllers have connected
  setTimeout(() => {
    const event = new CustomEvent(name, options)
    element.dispatchEvent(event)
  })
}
